/** * TYPESCRIPT TYPES ** */

import clsx from 'clsx'
import React from 'react'

import FlexStyle from './Flex.module.scss'

interface FlexProps {
  children?: any
  className?: string
  container?: boolean
  /** **** Container Props ******* */
  display?: 'flex' | 'block' | 'inline'
  flexdirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse'
  justify?:
    | 'flex-start'
    | 'end'
    | 'center'
    | 'between'
    | 'space-around'
    | 'initial'
    | 'inherit'
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse'
  alignitems?:
    | 'stretch'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'baseline'
    | 'initial'
    | 'inherit'

  gap?: number | string
  /** **** Child Props ******* */
  flexGrow?: number
  flexShrink?: number
  flexBasis?: number
  flex?: string
  /** **** Common Layout Props ******* */
  padding?: string
  margin?: string
  width?: string
  height?: string
  maxWidth?: string
  maxHeight?: string
  props?: any
  as?: keyof JSX.IntrinsicElements
  style?: React.CSSProperties
}

type FlexPropKey = keyof FlexProps

export const Flex = (props: FlexProps) => {
  const { className, ...rest } = props
  const Component = props.as ? props.as : 'div'

  const classNamesFromProps = () => {
    const classNames = (Object.keys(props) as FlexPropKey[]).map(
      (key: FlexPropKey) => {
        const value = props[key]
        return FlexStyle[`hnui-flex-${key}-${value}`]
      }
    )
    return classNames
  }

  return (
    <Component
      className={clsx(FlexStyle['hnui-flex'], className, classNamesFromProps())}
      {...rest}
    >
      {props.children}
    </Component>
  )
}
